import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/admin/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true, timeout: 15000 }
        );
        // Clear the fragment so the session_id isn't kept in history
        window.history.replaceState(null, "", "/admin");
        toast.success(`Welcome, ${res.data.name || res.data.email}`);
        navigate("/admin", { replace: true, state: { user: res.data } });
      } catch (err) {
        const detail =
          err?.response?.data?.detail ||
          "Sign-in failed. Please try again or contact Daz.";
        toast.error(typeof detail === "string" ? detail : "Sign-in failed.");
        navigate("/admin/login", { replace: true });
      }
    })();
  }, [location.hash, navigate]);

  return (
    <main
      data-testid="admin-callback-page"
      className="min-h-screen flex items-center justify-center bg-slate-50"
    >
      <div className="flex items-center gap-3 text-slate-700">
        <Loader2 className="w-6 h-6 animate-spin" />
        <span className="text-lg">Signing you in...</span>
      </div>
    </main>
  );
}
